import BaseModal from "./baseModal";

export default class Expertise extends BaseModal {

	constructor () {
		super("expertise-modal-bg", "expertise-modal");
		if(this.modal){
			this.init();
		}
	}

	init () {
		super.init();
		document.querySelectorAll('.modal-trigger').forEach(el => {
			el.addEventListener('click', () => {
				this.show();
			})
		});
	}


}
